import * as React from 'react'
import './History.scss'
import { ActionType, reducerStoreType, linkListType, linkDetailType } from "../../reducers/types";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { StyledTableCell } from "../../components/CustomUIComp/CustomTable";
import TableBody from "@material-ui/core/TableBody";
import noDataIcon from '../../images/null_icon.svg';
import { injectIntl, IntlShape } from 'react-intl'
import { connect } from "react-redux";
import { Dispatch } from "redux";
import CustomDialog from "../../components/CustomUIComp/CustomDialog";
import LinkDetailModal from "./LinkDetailModal";

interface IProps {
  dispatch: Dispatch<ActionType<any>>,
  linkList: linkListType[],
  currency: string,
  intl: IntlShape,
  linkDetail: linkDetailType
}

interface IState {
  modalOpen: boolean
}

class History extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      modalOpen: false
    }
  }

  openDialog = (detail: object) => {
    this.props.dispatch({ type: 'SET_LINK_DETAIL', payload: { detail: detail } })
    this.setState({
      modalOpen: true
    })
  }

  closeDialog = () => {
    this.setState({
      modalOpen: false
    })
  }

  public render() {
    let { linkList, intl } = this.props
    return (
      <div className="History">
        <div className="header">
          <h2>{intl.formatMessage({ id: 'linkList' })}</h2>
        </div>
        <div className="orderList">
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell align='center'>{intl.formatMessage({ id: 'transactionStatus' })}</StyledTableCell>
                <StyledTableCell align='center'>{intl.formatMessage({ id: 'amt' })}</StyledTableCell>
                <StyledTableCell align='center'>{intl.formatMessage({ id: 'payCurrency' })}</StyledTableCell>
                <StyledTableCell align='center'>{intl.formatMessage({ id: 'remark' })}</StyledTableCell>
                <StyledTableCell align='center'>{intl.formatMessage({ id: 'createTime' })}</StyledTableCell>
                <StyledTableCell align='center'>{intl.formatMessage({ id: 'payTime' })}</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {linkList.map((item, i) => {
                return (<TableRow hover key={`${item.id}-${i}`} onClick={() => this.openDialog(item)}>
                  <StyledTableCell align='center'>
                    {item.status === 0 ?
                      <span>
                        {intl.formatMessage({ id: 'unpaid' })}
                      </span> :
                      <span>
                        {intl.formatMessage({ id: 'paid' })}
                      </span>
                    }
                  </StyledTableCell>

                  <StyledTableCell align='center'>
                    <span>
                      {item.tradeAmt}
                    </span>
                  </StyledTableCell>
                  <StyledTableCell align='center'>
                    <span>
                      {item.currency}
                    </span>
                  </StyledTableCell>
                  <StyledTableCell align='center'>
                    {item.tradeSummary}
                  </StyledTableCell>
                  <StyledTableCell align='center'>
                    {item.createTime}
                  </StyledTableCell>
                  <StyledTableCell align='center'>
                    {item.payTime}
                  </StyledTableCell>
                </TableRow>)
              })}
            </TableBody>
          </Table>
          {linkList.length === 0 ?
            <div className="noData">
              <img src={noDataIcon} alt="no data" />
              <p>{intl.formatMessage({ id: 'noData' })}</p>
            </div>
            : null}
        </div>
        <CustomDialog open={this.state.modalOpen}
          title={intl.formatMessage({ id: 'linkDetail' })}
          showActions={false}
          content={<LinkDetailModal />}
          handleClose={this.closeDialog} />
      </div>
    );
  }
}
export default injectIntl(connect((state: reducerStoreType) => {
  return {
    linkDetail: state.searchLink.linkDetail,
    currency: state.merchant.merchantInfo.currency,
    linkList: state.searchLink.linkListInfo.list
  }
})(History))